// =============================================================================
// Origin UI — src/pages/employees/MyProfileRedirect.tsx
// Redirects /profile to the current user's employee record (/employees/{id}).
// Sets sessionStorage flag so the Sidebar highlights "My Profile" not "Employees".
// =============================================================================

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/services/apiService';

interface MeResponse {
  employeeId: string;
}

export function MyProfileRedirect() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const me = await api.get<MeResponse>('/api/employees/me');
        if (me?.employeeId) {
          const targetPath = `/employees/${me.employeeId}`;
          // Store in sessionStorage so the Sidebar knows this is "My Profile"
          sessionStorage.setItem('origin_my_profile_active', targetPath);
          navigate(targetPath, { replace: true });
        } else {
          setError('Employee record not found. Please contact HR.');
        }
      } catch {
        setError('Unable to load your employee profile. Please contact HR.');
      }
    })();
  }, [navigate]);

  if (error) {
    return (
      <div style={{ padding: 32, textAlign: 'center', color: '#666' }}>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: 32, textAlign: 'center', color: '#666' }}>
      <p>Loading your profile...</p>
    </div>
  );
}
